module.exports = __webpack_public_path__ + "static/media/calendar.4b7164dd.svg";